import React from 'react';
import { Option } from '../models/option';
import { MeasurementSystem } from '../enums/measurement-system.enum';
import { parseEngineVariables } from '../utils/engine-helper';
import { StepValues } from '../models/step-values';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import classnames from 'classnames';
import styles from './ButtonOption.module.scss';

interface Props {
  isSelected: boolean | undefined;
  option: Option;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  dataKey: any;
  activeMeasurement: any;
  style?: any;
  stepValues: StepValues;
  productHandle: ProductHandle;
}

export const ButtonOption: React.FC<Props> = (props) => {
  const optionText = props.option.text
    ? parseEngineVariables(props.option.text, props.stepValues, props.productHandle)
    : props.activeMeasurement === MeasurementSystem.Imperial
    ? props.option.imperialText
    : props.option.metricText;

  const lines = optionText?.split('/') ?? [optionText];

  return (
    <button className={classnames(styles.buttonOption, { [styles.selected]: props.isSelected })} onClick={(event) => props.onClick(event)}>
      {lines.length > 1 && <span>{lines[1]}</span>}
      <span>{lines[0]}</span>
    </button>
  );
};

export default ButtonOption;
